import { render, staticRenderFns } from "./TableBarberColoring.vue?vue&type=template&id=773e28d3&scoped=true"
import script from "./TableBarberColoring.vue?vue&type=script&lang=js"
export * from "./TableBarberColoring.vue?vue&type=script&lang=js"
import style0 from "./TableBarberColoring.vue?vue&type=style&index=0&id=773e28d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e28d3",
  null
  
)

export default component.exports